import { useRouter } from 'next/router';

import { TwoFactorAuthenticationForm } from '@zapier/authentication';
import { useSize } from '@zapier/identity-utils';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';
import { paramToBoolean } from '@zapier/auth-pages/src/utils';

export function TwoFactorAuthenticationPage() {
  const router = useRouter();
  const size = useSize();

  const next = router.query.next as string | undefined;
  const isReauth = paramToBoolean(router.query.reauth);
  const useRecoveryCode = paramToBoolean(router.query.use_recovery_code);
  const title = isReauth
    ? "Let's make sure it's you"
    : 'Log in to your account';

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={!isReauth && size !== 'small'}
      title={title}
      titlePosition="right"
    >
      <TwoFactorAuthenticationForm
        next={next}
        queryParams={router.query}
        useRecoveryCode={useRecoveryCode}
      />
    </AuthLayout>
  );
}
